---
title: Plan, ekstralar ve faturalar
parent: Belgeler
parentHref: /docs
---

<script>
  import DomainTlds from "@/components/domain-tlds.svelte"
</script>

# Plan, ekstralar, faturalar ve yasal sayfalar

## Her şeyin dahil olduğu tek bir plan

TOBY'de kurulum ücreti ve gizli katmanlar olmayan, her şeyin dahil olduğu tek bir eksiksiz plan bulunmaktadır:

- **Aylık veya yıllık ödeme:** Esnek aylık ödemeyi (istediğiniz zaman aylık iptal edilebilir) veya indirimli yıllık ödemeyi (fatura ile de ödenebilir) seçin. Güncel fiyatlar için [fiyat listesine](/tr/pricing) bakın.

Her abonelik şunları içerir:

- **Kendi alan adınız** (<DomainTlds />) — mevcut bir alan adının transferini de içerir (Domain-Umzug)
- **1 e-posta adresi** (info@...) ile **15 GB posta kutusu (Maxi-Postfach)** ve sınırsız yönlendirme adresleri
- **15 sayfaya kadar** — sohbet, sesli komut veya fotoğraf yüklemesi ile oluşturulur ve yönetilir
- **1 ek dil** (toplamda 2 dil) yayınladığınızda otomatik çeviri ile
- **Bülten** ile ayda **1.000 e-posta**
- **Ziyaretçi analizi** (gizlilik odaklı, çerez bildirimleri olmadan)
- **Posta ile başlangıç paketi** (kapı etiketi ve A5 QR masa standı)
- **AB'de barındırma** otomatik SSL güvenliği ile

## İsteğe bağlı ekstralar

İşletmeniz dahil edilen limitleri aşarsa, **Ayarlar → Abonelik** altından istediğiniz zaman esnek yapı taşları ekleyebilirsiniz (aylık iptal edilebilir, bkz. [fiyat listesi](/tr/pricing)):

- **+15 GB e-posta depolama alanı** (veya ek bir posta kutusu)
- **+1 ek web sitesi dili**
- **+15 ek sayfa**
- **Ayda +5.000 bülten e-postası**

## Düzgün bir işletme faturası almak (Web sitesi ve Google Play karşılaştırması)

Bir işletme, muayenehane veya serbest meslek hesabı işletiyorsanız ve şirket adınız, işletme adresiniz ve KDV'nin (MwSt.) ayrı gösterildiği **düzgün vergi indirilebilir bir işletme faturası (ordentliche Rechnung)** ihtiyacınız varsa, lütfen nereden abone olduğunuza dikkat edin:

- **Web sitesinden abone olma (tobysite.com üzerinden Stripe ile):** Bizden her zaman işletmenize hitaben **KDV'li düzgün bir işletme faturası** alırsınız. Tüm geçmiş faturalarınızı indirebilir ve şirket fatura adresinizi istediğiniz zaman **Ayarlar → Abonelik** altından güncelleyebilirsiniz.
- **Android uygulamasından abone olma (Google Play Uygulama İçi Satın Alma):** Google Play üzerinden abone olduğunuzda, Google ödemeyi kayıt tüccarı olarak işler ve yalnızca standart bir Google Play ödeme makbuzu düzenler. **Google Play üzerinden faturalandırılan abonelikler için işletme KDV faturası (ordentliche Rechnung) düzenleyemeyiz.**

> **İpucu:** Düzgün Stripe işletme faturaları almak için tarayıcınızda **tobysite.com** üzerinden abone olabilir ve TOBY Android ve iOS uygulamalarını hesabınızla ekstra ücret ödemeden kullanabilirsiniz.

## Künye (Impressum) ve Gizlilik Politikanızı (Datenschutz) ekleme

- **Kendi yasal metniniz:** Yasal gereksinimler işletme yapınıza, mesleğinize ve ülkenize bağlı olduğundan, **TOBY kendi başına yasal tavsiye üretmez veya yasal metinler (Impressum veya Datenschutzerklärung) yazmaz.**
- **Bunları nasıl eklersiniz:** Mevcut Künye veya Gizlilik Politikası metninizi sohbete yapıştırın (veya Word/PDF belgesi olarak yükleyin, ya da TOBY'den eski web sitenizden kopyalamasını isteyin) ve *"Bunu Künye sayfamıza koy."* deyin. TOBY sayfaları oluşturacak ve web sitesi alt bilginizde düzgün bir şekilde bağlantılarını ekleyecektir.
